// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_d1-0";